/* eslint-disable react/button-has-type */
import './simpleButton.css';

function SimpleButton(props) {
  const { text, bgColor, onClick, type, children } = props;
  return (
    <div>
      <button
        onClick={onClick}
        type={type ? '' : 'button'}
        className="simple_btn"
        style={{ backgroundColor: bgColor }}
      >
        {text || ''} {children}
      </button>
    </div>
  );
}

export default SimpleButton;
